// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"c3bbf614","410":"97d13c1e","679":"d60b675e","758":"3186dffb","982":"23cfe7ae"}[chunkId] + ".chunk.js";
};